import { RenderContent } from "components/content-renderer";
import { EventCard } from "components/event-card";
import { GetEventQuery } from "lib/graphql-generated";
import { DateObject } from "lib/utils";

interface Props {
  event: GetEventQuery["events"][number];
}
export const FestivalPage = ({ event }: Props) => {
  const startTime = DateObject(event.start_time);
  const endTime = DateObject(event.end_time);

  return (
    <>
      <article
        className='bg-green-default p-4 md:p-12
        lg:p-16 max-w-screen-xl mx-auto mb-12 text-white'>
        <div className='md:border-8 md:p-8 lg:p-12 border-green-light rounded-lg md:grid grid-cols-3 md:gap-x-8 lg:gap-x-12'>
          <header className='flex mt-8 md:mt-0 flex-col col-span-full'>
            <span className='text-lg lg:text-2xl'>Festival</span>
            <h1 className='header text-5xl lg:text-7xl'>{event.title}</h1>
            <section className=' mb-6 space-y-2'>
              <dl className='flex flex-col w-max text-xl'>
                <div className='flex flex-row space-x-2  w-max text-xl'>
                  <dt className='m-auto header'>Date:</dt>
                  <dd className='mb-1.5'>
                    {startTime.day}.{startTime.month}.{startTime.year} :{" "}
                    {startTime.hour}:{startTime.minute} - {endTime.hour}:
                    {endTime.minute}
                  </dd>
                </div>
              </dl>
            </section>
          </header>
          <section className='col-span-full mt-8'>
            <img
              src={event.image}
              alt={`image for event: ${event.title}`}
              className='w-full mt-auto'
            />
          </section>

          <section className='flex flex-col col-span-full mt-16 bg-green-light'>
            <article className='pt-16'>
              <h2 className='header text-lg text-center'>About</h2>
              <div className='mx-auto prose px-2'>
                <RenderContent content={event.description} darkBackground />
              </div>
            </article>
          </section>
          <section className='mt-16 bg-green-light col-span-full gap-8 grid md:grid-cols-2 p-2 md:p-8'>
            <h2 className='col-span-full header text-lg text-center'>
              Events:
            </h2>
            {event.events.map((e) => (
              <EventCard event={e} />
            ))}
          </section>
        </div>
      </article>
    </>
  );
};
